<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { vOnClickOutside } from '@vueuse/components';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';
import ConversationMeetingsAPI from 'dashboard/api/conversationMeetings';

const props = defineProps({
  conversation: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const loading = ref(false);
const isOpen = ref(false);
const recordMeeting = ref(true);

const toggleOptions = () => {
  isOpen.value = !isOpen.value;
};

const closeOptions = () => {
  isOpen.value = false;
};

const startMeeting = async () => {
  if (loading.value) return;
  loading.value = true;
  try {
    const { data } = await ConversationMeetingsAPI.create(
      props.conversation.id,
      recordMeeting.value
    );
    isOpen.value = false;
    window.open(data.host_url, '_blank', 'noopener,noreferrer');
  } catch (e) {
    useAlert(t('MEETINGS.ERROR_GENERIC'));
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <span v-on-click-outside="closeOptions" class="relative contents">
    <Button
      v-tooltip.top-end="$t('MEETINGS.START_VIDEO')"
      icon="i-ph-video-camera"
      sm
      faded
      slate
      :is-loading="loading"
      @click="toggleOptions"
    />
    <div
      v-if="isOpen"
      class="absolute z-50 p-3 mt-1 border rounded-lg shadow-lg top-full right-0 w-60 bg-n-solid-1 border-n-container"
    >
      <label class="flex items-center justify-between gap-2 cursor-pointer">
        <span class="text-sm text-n-slate-12">
          {{ t('MEETINGS.RECORD_TOGGLE') }}
        </span>
        <Switch v-model="recordMeeting" />
      </label>
      <Button
        class="w-full mt-3"
        sm
        solid
        blue
        :is-loading="loading"
        :label="t('MEETINGS.START_VIDEO')"
        @click="startMeeting"
      />
    </div>
  </span>
</template>
